import { FC } from 'react';

import { InputMod } from '@enums';
import type { InputTextProps } from '@types';
import { validateValueEqual } from '@utils';

import { BaseTextInput, FilledTextInput, NumberTextInput } from '.';

export const TextInput: FC<InputTextProps> = ({ type, inputMod, ...props }) => {
  if (validateValueEqual(type, 'number')) {
    return <NumberTextInput type={type} {...props} inputMod={inputMod} />;
  } else if (validateValueEqual(inputMod, InputMod.Filled)) {
    return <FilledTextInput type={type} {...props} inputMod={inputMod} />;
  }
  return <BaseTextInput {...props} />;
};
